import axios from "axios";
import { decryptData } from "../utils/decrypt";
import errorAlert from "../views/errors/errorAlert";

const BASE_URL = process.env.REACT_APP_API_URL;

export const requestAccessApi = async (value, tempToken) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/auth-get-access-device`, value, {
      headers: { Authorization: `Bearer ${tempToken}` },
    });
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
};

export const checkAuthApi = async (value) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/check-auth`, value);
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
};

export const requestAuthApi = async (value) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/request-auth`, value);
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
};

export const AllowAccess = async (value) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/auth/auth-allow-access-device`,
      value,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return decryptData(response);
  } catch (error) {
    errorAlert(error);
  }
};

export const validateToken = async (token) => {
  try {
    const response = await axios
    .get(`${BASE_URL}/auth/validate-token?token=${token}`)
    return response;
  } catch (error) {
    errorAlert(error.response?.data?.message);
  }
};

export const resetPassword = async (email) => {
  try {
    const response = await axios
    .post(`${BASE_URL}/users/reset-password`,{email: email})
    return decryptData(response);
  } catch (error) {
    errorAlert(error?.response?.data?.message);
  }
};

export const createPassword = async (token, password) => {
  try {
    const response = await axios
    .post(`${BASE_URL}/users/create-password`,{token:token, password:password})
    return response;
  } catch (error) {
    errorAlert(error.response?.data?.message);
  }
};